import { useTranslation } from 'react-i18next';

/**
 * Map an i18next language code to a BCP-47 locale for Intl.* APIs.
 *
 * Numbers and dates are formatted with regional conventions, not the bare
 * language code: 'es' is rendered as Mexican Spanish ('es-MX' — the brand's
 * primary market), 'en' as US English ('en-US').
 */
const LOCALE_MAP = {
  es: 'es-MX',
  en: 'en-US',
  zh: 'zh-CN',
  ja: 'ja-JP',
};

export const DEFAULT_LOCALE = 'es-MX';

/**
 * Returns the active BCP-47 locale string for use with `Intl.NumberFormat`,
 * `Date.prototype.toLocaleDateString`, etc.
 *
 * Always returns a non-empty locale — falls back to `es-MX` if i18next has
 * not initialized yet or reports an unknown language.
 */
export function useLocale() {
  const { i18n } = useTranslation();
  const lang = (i18n.resolvedLanguage || i18n.language || 'es').slice(0, 2);
  return LOCALE_MAP[lang] || DEFAULT_LOCALE;
}

export default useLocale;
